import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, Mail, X } from "lucide-react";
import { api } from "../../lib/api";

const errText = (e, fb) => (typeof e?.response?.data?.detail === "string" ? e.response.data.detail : fb);

export const EstimateShareDialog = ({ estimate, email, onClose, onSent }) => {
  const [url, setUrl] = useState("");
  const [to, setTo] = useState(estimate.share?.sent_to || email || "");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.post(`/admin/estimates/${estimate.id}/share`).then((r) => setUrl(r.data.url)).catch((e) => toast.error(errText(e, "リンクを作成できませんでした")));
  }, [estimate.id]);
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); toast.success("リンクをコピーしました。LINEなどに貼り付けて送れます"); } catch { toast.error("コピーできませんでした。手で選択してコピーしてください"); }
  };
  const send = async () => {
    setBusy(true);
    try { await api.post(`/admin/estimates/${estimate.id}/send`, { to, message }); toast.success(`${to} に送信しました`); onSent(); onClose(); } catch (e) { toast.error(errText(e, "送信できませんでした")); } finally { setBusy(false); }
  };
  const cls = "w-full border border-line bg-ink px-3 py-2.5 text-sm text-white outline-none focus:border-accent";
  return (
    <div data-testid="estimate-share-dialog" className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4" onClick={onClose}>
      <div className="w-full max-w-lg space-y-4 border border-line bg-coal p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between"><div><p className="font-bold text-white">お客様へ見積書を送る</p><p className="mt-1 text-xs text-gray-500">{estimate.estimate_number}　{estimate.title}</p></div><button data-testid="estimate-share-close" onClick={onClose} className="text-gray-400"><X className="h-5 w-5" /></button></div>
        <p className="text-xs text-gray-400">お客様はリンクから見積書を確認し、手書きサインで注文できます（有効期限：{estimate.valid_until || "発行から30日"}まで）。</p>
        <div className="space-y-2">
          <p className="font-mono text-[10px] tracking-[0.3em] text-gray-500">① リンクを自分で送る（LINEなど）</p>
          <div className="flex gap-2"><input data-testid="estimate-share-url" readOnly value={url} onFocus={(e) => e.target.select()} className={`${cls} font-mono text-xs`} /><button data-testid="estimate-share-copy" disabled={!url} onClick={copy} className="flex items-center gap-1 border border-accent/60 px-3 text-xs text-accent"><Copy className="h-4 w-4" />コピー</button></div>
        </div>
        <div className="space-y-2">
          <p className="font-mono text-[10px] tracking-[0.3em] text-gray-500">② 会社のメールで送る</p>
          <input data-testid="estimate-share-to" type="email" value={to} onChange={(e) => setTo(e.target.value)} placeholder="お客様のメールアドレス" className={cls} />
          <textarea data-testid="estimate-share-message" rows={3} value={message} onChange={(e) => setMessage(e.target.value)} placeholder="ひとことメッセージ（任意）" className={cls} />
          <button data-testid="estimate-share-send" disabled={busy || !url || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(to)} onClick={send} className="flex w-full items-center justify-center gap-2 bg-accent py-3 text-sm font-bold text-ink disabled:opacity-40"><Mail className="h-4 w-4" />{busy ? "送信中…" : "メールで送信"}</button>
          {estimate.share?.sent_at && <p className="text-xs text-gray-500">前回送信：{estimate.share.sent_to}（{new Date(estimate.share.sent_at).toLocaleString("ja-JP")}）</p>}
        </div>
      </div>
    </div>
  );
};
